import { useQuery } from "react-query";
import { ParamsGetUkm, GetUkmResponse } from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params: ParamsGetUkm) => {
    const apiGetUkm = queryString.stringifyUrl({
        url: "api/ukm",
        query: {
            search: `${params.search}`,
            size: params.size,
            page: params.page,
            isNaikKelas: 1,
        },
    });
    const { data } = await axios.get<GetUkmResponse>(apiGetUkm);
    return data.data;
};

export default function useUkm(params: ParamsGetUkm) {
    return useQuery<GetUkmResponse["data"]>(["ukm", params], () =>
        handleRequest(params),
    );
}
